<template>
    <div>
        <button-el href="javascript:void(0)" v-on:click.native="modal.showModal = true" v-bind:button-text="buttonText" v-bind:button-class="buttonClass"></button-el>
        <modal
                v-if="modal.showModal"
                v-on:submit="sendFeedback"
                v-bind:width="modal.width"
                v-bind:height="modal.height"
                v-bind:buttonText="modal.buttonText"
                v-bind:buttonClass="modal.buttonClass"
                v-bind:header="modal.header"
                v-bind:body="modal.body"
                v-bind:footer="modal.footer"
                @close="modal.showModal = false">
                <template #body>
                    <p>Введи свой номер телефона/Email</p>
                    <form>
                        <input v-model="model.contact" type="text" name="request[phone]" placeholder="Телефон/Email">
                        <input type="checkbox" id="privacy-policy" name="request[policy]">
                    </form>
                </template>
        </modal>
        <modal
                v-if="requestDone.showModal"
                v-on:submit="requestDone.showModal = false"
                v-bind:width="requestDone.width"
                v-bind:height="requestDone.height"
                v-bind:buttonText="requestDone.buttonText"
                v-bind:buttonClass="requestDone.buttonClass"
                v-bind:header="requestDone.header"
                v-bind:body="requestDone.body"
                v-bind:footer="requestDone.footer"
                @close="requestDone.showModal = false">
                <template #body>
                    <div style="display: flex; flex-flow: column; padding-top: 5px;" v-html="requestDone.body"></div>
                </template>
        </modal>
    </div>
</template>

<script>
    import ButtonEl from '../elements/ButtonEl.vue'
    import Modal from '../Modal.vue'
    export default {
        props: {
            formTag: {
                default: false
            },
            buttonClass: {
                default: 'white big'
            },
            buttonText: {
                default: 'Отправить заявку'
            }
        },
        data() {
            return {
                nameInputPlaceholder: 'Ваше имя',
                phoneInputPlaceholder: 'Телефон/Email',
                checkBoxHtml: 'Я согласен с <span class="bold"><a class="dark-blue" href="javascript:void(0)">Политикой конфиденциальности</a></span>',
                textAreaPlaceholder: 'Тут вы можете описать объект внедрения',
                model: {
                    contact: ''
                },
                requestDone: {
                    showModal: false,
                    width: '685px',
                    height: '380px',
                    header: '<span class="green">Мы получили вашу заявку</span>',
                    body: '',
                    buttonText: '',
                    buttonClass: 'big white no-float'
                },
                modal: {
                    showModal: false,
                    width: '685px',
                    height: '565px',
                    header: 'Получите консультацию<br />прямо сейчас',
                    body: '',
                    buttonText: 'Отправить заявку',
                    buttonClass: 'big yellow no-float'
                }
            }
        },
        components: {
            ButtonEl,
            Modal
        },
        watch: {
        },
        methods: {
            async sendFeedback() {
                this.modal.showModal = false
                this.requestDone.body = ''
                this.requestDone.header = ''
                let r = await this.$store.dispatch('apiSendFeedback', this.model)
                if (r.success) {
                    this.requestDone.header = '<span class="green">Мы получили вашу заявку</span>'
                    setTimeout(function () {this.requestDone.showModal = false}.bind(this), 3000)
                } else {
                    if ('message' in r) {
                        this.requestDone.header = '<span class="red">Что-то пошло не так</span>'
                        this.requestDone.body = '<span class="red">' + r.message + '</span>'
                    } else {
                        this.requestDone.header = '<span class="red">Что-то пошло не так</span>'
                        this.requestDone.body = '<span class="">Попробуйте позже или свяжитесь с нами сами</span>'+'<span>Тел. 8 800 3500 868</span>'+'<span>Email st@i868.ru</span>'
                    }
                }
                this.requestDone.showModal = true
            }
        }
    }
</script>
<style scoped>
    div {
        padding: 40px 0 27px 0;
        font-size: 18px;
    }

    form {
        width: 695px;
        /*margin: 62px auto;*/
    }

    input.inline {
        display: inline-block;
        width: 345px;
        height: 56px;
        border: none;
        padding: 10px 18px;
        font-size: 14px;
        font-weight: 700;
    }

    input.inline:-moz-placeholder,
    input.inline:-ms-input-placeholder,
    input.inline::-moz-placeholder,
    input.inline::-webkit-input-placeholder {
        color: #b0aeae;
        font-weight: 300 !important;
    }

    textarea {
        resize: none;
        border: none;
        display: block;
        margin: 10px auto;
        width: 695px;
        height: 80px;
        padding: 15px 17px;
        font-size: 14px;
    }

    section {
        margin-top: 20px;
    }

    @media screen and (max-width: 992px) {
        form {
            width: auto;
        }

        input.inline {
            width: 45%;
        }

        textarea {
            width: calc(90% + 6px);
        }

        section.text-left {
            width: calc(90% + 6px);
            margin: 0 auto;
        }
    }

    @media screen and (max-width: 576px) {
        form {
            width: auto;
        }

        input.inline {
            width: calc(90% + 6px);
            margin-bottom: 15px;
        }

        textarea {
            width: calc(90% + 6px);
        }

        a.big.white {
            float: none;
            margin: 32px auto;
            display: inline-block;
            text-align: center;
        }

        section.text-left {
            text-align: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/main/RequestButton.vue